import { getFlowFromState } from 'src/store/flow_listeners';

import type { IsEligibleForExperimentFn } from './experimentPage';
import { FlowPage } from './FlowPage';

/**
 * A helper to pass in a FlowPage.isEnabled fn and use it in the eligibility
 * check for an experiment:
 *
 * ```
 * createExperimentPage(
 *   "myExperiment",
 *   { ...variant config  },
 *   eligibleWhenEnabled(treatmentPage.isEnabled)
 * )
 * ```
 *
 * This will make it so that if your experiment page is only enabled for
 * non-agent users then we will also only bucket non-agent users for the experiment
 */
export const eligibleWhenEnabled =
  (isEnabled: FlowPage['isEnabled']): IsEligibleForExperimentFn =>
  (listenerApi) => {
    const { context } = getFlowFromState(listenerApi.getState());
    return isEnabled(context);
  };
